<template>
	<div class="like-c" v-if="show" @click.stop>
        <div @click="addLike" class="wrap">
            <div class="icon">
                <div :class="[isLiked?'like-icon':'no-like-icon']"></div>
                <div class="like-note" ref="plusOne">+1</div>
            </div>
            <div class="count">{{ likeCount }}</div>
        </div>
		<DialogLogin v-if="showDialogLogin" @closeDialogLogin="handleShowDialogLogin"/>
	</div>
</template>

<script>
import { getCookie } from "mpfe-utils"
import { addArticleLike,syncLikeArticle } from '../../request/request'
import localstorageUtil from "@/_utils/localstorageUtil";
import DialogLogin from '../dialogLogin.vue'
import { importLogin } from '@/utils/login'
import { getUserInfo } from '@/request/request'

export default {
    props: ['likeData'],
	name: "",
	components: {
		DialogLogin,
	},
    watch: {
        likeData: {
            handler: function (newValue, oldValue) {
                console.log(3333,newValue)
               this.isLiked = newValue?.isLiked || false
               this.likeCount = this.setCount(newValue?.likeCount || 0)
            },
            deep: true
        }
    },
	data() {
		return {
			likeCount: '',
			text: '',
			isLiked: false,
			source_id: 'mp_' + window.pcArticleInfo?.news_id,
			title: window.pcArticleInfo?.title,
			showDialogLogin: false
		}
	},
	mounted() {
		this.init()
		// 监听登录成功
		window.EVENT_BUS.$on('loginSuccess',this.listenLoginSuccess)
	},
	computed: {
		show() {
			return window.pcArticleInfo?.sGrade == 0
		}
	},


	methods: {
        setCount(count) {
            let num = "";
            if(!count)return '首赞'
            if (999 > count > 0) {
                num = count;
            } else if (count > 999) {
                num = `999+`;
            }
            return num;
        },
		init() {
			// 初始化登录态-尝试同步游客点赞
            getUserInfo().then((res) => {
                if (res?.code == 1 && res?.data) {
                    syncLikeArticle()
                }
            })
            .catch((error) => {
                console.log('获取用户信息失败', error)
            })
		},
		addLike () {
			const p = {
				visitorId: getCookie('SUV'),
				source_id: this.source_id,
				is_like: !this.isLiked, // false
				topic_title: this.title,
				topic_url: location.protocol + '//' + location.host + location.pathname,
			}
			// 点赞接口
			addArticleLike(p).then((res)=>{
				if(res && res.code == 1) {
					// 点赞成功
                    console.log(4444,res.data)
					this.likeCount = res.data == 0 ? '首赞' : this.setCount(res.data)
					this.isLiked = !this.isLiked
					// 点赞动效
					if(this.isLiked) {
						var plusOne =this.$refs['plusOne']
						var timer1 = setTimeout(function() {
							plusOne?.classList?.add('plus')
						}, 0)
						var timer2 = setTimeout(function() {
							plusOne?.classList?.remove('plus')
							clearTimeout(timer1)
							clearTimeout(timer2)
						}, 300)

						let isFirstThumb = localstorageUtil.getItem('isFirstThumb')
						//  每天首次点赞出引导登录弹窗
						if(!getCookie('ppinf') && !isFirstThumb) {
							this.handleShowDialogLogin({show:true})
							// 第二天消失
							var currentTime = new Date().getTime();
							var targetTime = new Date(new Date(new Date().getTime()+24*60*60*1000).setHours(0,0,0,0)).getTime()// 设置目标时间为今天晚上12点
							var remainingMilliseconds = targetTime - currentTime // 计算剩余毫秒数
							localstorageUtil.setItem('isFirstThumb',remainingMilliseconds)
						}
					}
				}else {
                    this.$toast('点赞失败，稍后重试',2000)
				}
			}).catch(()=>{
                this.$toast('点赞失败，稍后重试',2000)
			})
			.finally(()=>{
				window?.sohuSpm?.sendAction({
					acode: 9141,
					clkParam: 's:'+ (+this.isLiked),
				});
			})

    	},

		handleShowDialogLogin(data) {
			const {show,goLogin} = data
			if(goLogin) {
				importLogin().then((res)=>{
					const loginIndex = res.loginIndex
					loginIndex.login()
				})
			}else {
				this.showDialogLogin = show
			}
		},
		// 监听登录成功
        listenLoginSuccess() {
            if(this.showDialogLogin) {
				this.handleShowDialogLogin({show:false})
				window.open(document.location.origin + '/ucenter/likeArticle','_blank')
			}
			// 登陆成功后同步游客点赞
			syncLikeArticle()
        },
	}
}
</script>

<style lang="less" scoped>
.like-c {
    .wrap {
        .icon {
            width: 48px;
            height: 48px;
            background: #F8F8F8;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            .like-note {
                position: absolute;
                top: -6px;
                left: 20px;
                color: #da2228;
                font-weight: 500;
                font-size: 16px;
                line-height: 22px;
                text-align: center;
                opacity: 0;
                &.plus {
                    opacity: 1;
                    top: -26px;
                    transition: all ease-in-out .3s;
                }
            }
            .like-icon {
                width: 22px;
                height: 22px;
                background: url('//statics.itc.cn/mptc-mpfe/img/article/icon_praised.png');
                background-size: 100% 100%;

            }
            .no-like-icon {
                width: 22px;
                height: 22px;
                background: url('//statics.itc.cn/mptc-mpfe/img/article/icon_praise_empty.png');
                background-size: 100% 100%;
            }
        }
        &:hover {
            cursor: pointer;
        }
    }
    .count {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #111111;
        line-height: 17px;
        height: 17px;
        text-align: left;
        font-style: normal;
        margin-top: 4px;
        margin-bottom: 24px;
        text-align: center;
    }
  }

.article-like {
    position: relative;
    margin-top: 16px;
    box-sizing: border-box;
    float: left;
    width: 80px;
    height: 34px;
    border: 1px solid #e5e5e5;
    border-radius: 17px;
    text-align: center;
    cursor: pointer;

    .like-text {
        position: relative;
        display: inline-block;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 6px 0 9px;
        line-height: 17px;
        color: #606060;
        font-size: 12px;
        em {
            line-height: 20px;
        }
    }
    .like-note {
        position: absolute;
        top: -6px;
        left: 32px;
        color: #da2228;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        opacity: 0;
        &.plus {
            opacity: 1;
            top: -26px;
            transition: all ease-in-out .3s;
        }
    }
    .icon-like {
        display: inline-block;
        width: 17px;
        height: 17px;
        line-height: 18px;
        background:url(../../images/article-like.png) no-repeat 100% 100%;
        margin-right: 5px;
    }
    &.liked {
        border-color: #ed9194;
        .like-text {
            color: #da2228;
        }
        .icon-like {
            background:url(../../images/article-liked.png) no-repeat 100% 100%;
        }
    }
    .toast {
        display: none;
        position: fixed;
        margin: 0 auto;
        z-index: 999;
        top: 80px;
        .toast-text {
            margin-left:20px;
            width: 600px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #ffffff;
            color: #303030;
            box-shadow: 3px 3px 10px rgba(0,0,0,.12);
        }
    }
}
</style>
